import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import EmployeeSVG from "../../Components/SVGS/EmployeeSVG";
import InputField from "../../Components/InputField/InputField";
import Select from "react-select";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import noImage from "../../Assests/avatar1.png";
import { postHomeData } from "../../api";
import JoditEditor from "jodit-react";
import { HiHome } from "react-icons/hi";

export default function HomeScreenAddEdit({ isEdit }) {
    const icon = () => {
        return <HiHome size="28" fill="#DF2F35" />;
    };

    const navigate = useNavigate();
    const location = useLocation();
    const prevData =
        location.state && location.state ? location.state.editData : null;
    const page = location.state && location.state ? location.state.page : null;

    let baseUrl = process.env.REACT_APP_BASE_URL;
    const editor = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [nameErr, setNameErr] = useState(false);
    const [err, setErr] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [updatedData, setUpdatedData] = useState({
        id: prevData ? prevData.id : 0,
        name: prevData ? prevData.name : "",
        description: prevData ? prevData.description : "",
    });

    // fetching initial data
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData({ ...updatedData, [name]: value });
    };

    const saveOnclick = () => {
        if (!updatedData.name) setNameErr(true)
        else {
            let formData = new FormData();
            formData.append("id", updatedData.id);
            formData.append("name", updatedData.name);
            formData.append("description", updatedData.description);
            isEdit ? formData.append("image", '') :
                formData.append("image_file", '');
            setErr(false);
            setIsLoading(true);
            postHomeData(formData).then(({ data }) => {
                setIsLoading(false);
                if (data.error_code == 0 || data.error_code == 1) {
                    navigate("/dashboard/home", {
                        state: { page: page },
                    });
                }
                else if (data.error_code == 2) {
                    setErr(true)
                    setErrMsg('Oops some server error occured.')
                }
                else {
                    setErr(true)
                    setErrMsg('Oops some server error occured. EC:' + data.error_code)

                }
            }).catch(err => {
                setIsLoading(false);
                setErr(true)
                setErrMsg('Network Error!.')
            })
        }
    };

    return (
        <>
            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText={"Home"} />
                </div>
                <div className="dashPanel" style={{ position: "relative" }}>
                    <h4
                        style={{
                            display: err ? "flex" : "none",
                            justifyContent: "center",
                            color: "red",
                        }}
                    >
                        <p>Network Error! Check your Network connnection.</p>
                    </h4>
                    <>
                        <div className="ar-dashpanel">
                            <h4
                                style={{
                                    display: err ? "flex" : "none",
                                    justifyContent: "center",
                                    color: "red",
                                    position: "absolute",
                                    top: "0",
                                    width: "90%",
                                }}
                            >
                                <p>Error! {errMsg}.</p>
                            </h4>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                    }}
                                >
                                    <LoadingSpinner />
                                </div>
                            ) : (
                                <div style={{ flex: 1 }}>

                                    <div className="ae-formFields">
                                        <div className="ae-inputField">
                                            <InputField
                                                name={"name"}
                                                isErr={nameErr}
                                                errorMsg={
                                                    "Title is required"
                                                }
                                                value={updatedData.name}
                                                onChange={(e) => {
                                                    setNameErr(false);
                                                    handleChange(e);
                                                }}
                                                placeholder={"Title"}
                                                radius="5px"
                                            />
                                        </div>

                                    </div>
                                    <div style={{ margin: "50px 0", width: '90%' }}>
                                        <p className="if-txt">Description</p>
                                        <JoditEditor
                                            ref={editor}
                                            value={updatedData.description}
                                            onBlur={(newContent) => setUpdatedData({
                                                ...updatedData,
                                                description: newContent,
                                            })}
                                        />
                                    </div>

                                </div>
                            )}
                            <div className="addEdit-btns">
                                <div className="ev-btnAdd ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Update" : "Add"}
                                        func={saveOnclick}
                                        disabled={isLoading}
                                        color="#DF2F35"
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                                <div className="ev-btnDel ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Discard" : "Back"}
                                        color="#0061B1"
                                        func={() => {
                                            navigate("/dashboard/home", {
                                                state: { page: page },
                                            });
                                        }}
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}

